import Http from '../utils/Http';
import * as authActions from "../stores/actions/auth";
import * as moduleActions from "../stores/actions/modules";
import { module } from "../stores/models/Module";

export function getAllowedModules() {
  return dispatch =>
    new Promise((resolve, reject) => {
      dispatch(moduleActions.fetchModulesRequest());

      Http.get('/modules/allowed')
        .then(res => {
          if (res.data && res.data.data) {
            const modules = res.data.data.map(element => module(element));
            dispatch(moduleActions.fetchModulesResolved(modules, res.data.meta));
            resolve(modules);
          } else {
            const error = new Error(res.data.meta?.message || 'Failed to load modules');
            dispatch(authActions.serverError(error.message));
            reject(error);
          }
        })
        .catch(err => {
          const errorMessage = err.response?.data?.meta?.message || err.message || 'An error occurred while loading modules';
          dispatch(authActions.serverError(errorMessage));
          reject(err);
        });
    });
}

export function updateSelectedModule(selectedModule) {
  return dispatch =>
    new Promise((resolve, reject) => {
      Http.post('/modules/selected', { selectedModule })
        .then(res => {
          if (res.data && res.data.success) {
            dispatch(authActions.serverSuccess('Module switched successfully'));
            window.location.href = res.data.redirect_url;
            resolve(res.data);
          } else {
            const error = new Error(res.data.meta?.message || 'Failed to update selected module');
            dispatch(authActions.serverError(error.message));
            reject(error);
          }
        })
        .catch(err => {
          const errorMessage = err.response?.data?.meta?.message || err.message || 'An error occurred while updating module';
          dispatch(authActions.serverError(errorMessage));
          reject(err);
        });
    });
}
